import React from 'react';
import * as _ from 'lodash';
import { DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormDropdownRadio } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import '../../../styles/organisms/jv-company-branch.scss';

export class JvCompanyBranchDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false, // コンポーネント開閉フラグ
      list: this.props.companyBranches, // コンポーネント内データ
      searchWord: '', // 検索ワード
      selected: {
        id: this.props.id, // 選択ID
      },
    };

    this.allCompanyBranches = this.props.companyBranches; // 全支店リスト
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    ); // コンポーネント外クリック判定メソッド
    this.parent = React.createRef();
    this.searchTimer;
  }

  componentDidUpdate() {
    if (this.state.show === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.show === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.state.list, nextProps.companyBranches)) {
      // JV会社を選択、
      // JV会社が変更され、JV支店コンポーネント内の情報が変化、
      // JV会社の末尾以外が削除され、JV支店コンポーネント内の情報が変化した場合、
      // 支店情報を更新
      this.allCompanyBranches = nextProps.companyBranches;
      this.setState({ list: nextProps.companyBranches });
    }
    if (!_.isUndefined(this.state.selected.id) && _.isUndefined(nextProps.id)) {
      // JV支店を選択した状態でJV会社を変更、
      // 削除したJV会社の次の行にJV支店が設定されていない場合、
      // JV支店を削除
      this.setState({ selected: {} });
    } else if (
      (!_.isUndefined(this.state.selected.id) &&
        !_.isUndefined(nextProps.id) &&
        this.state.selected.id !== nextProps.id) ||
      (_.isUndefined(this.state.selected.id) && !_.isUndefined(nextProps.id))
    ) {
      // 削除したJV会社の次の行に異なるJV支店が設定されている場合、
      // 次の行のJV支店を設定
      const selected = {
        id: nextProps.id,
        name: nextProps.value,
      };
      this.setState({ selected });
    }
  }

  /**
   * @description JVコンポーネントの開閉状態を設定
   */
  handleShowForm() {
    if (this.props.enable === true && this.props.detailFlg !== true) {
      // 登録、編集画面かつJV会社を選択されている場合
      this.setState({ show: !this.state.show });
    }
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent(e) {
    if (this.parent.current && this.parent.current.contains(e.target)) {
      // コンポーネント内クリックの場合
      return;
    }
    // コンポーネント外クリックの場合、コンポーネントを不可視にする
    this.setState({ show: false });
  }

  /**
   * @description 検索ワードを設定
   * @param {string} searchWord 検索ワード
   */
  inputSearchWord(searchWord) {
    this.setState({ searchWord }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchJvCompanyBranches();
      }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
    });
  }

  /**
   * @description JV支店検索
   */
  searchJvCompanyBranches() {
    let list = [];
    const searchWord = this.state.searchWord;
    if (!_.isUndefined(searchWord)) {
      // 検索ワードが設定されている場合、全支店情報から抽出
      list = _.filter(this.allCompanyBranches, item =>
        _.includes(item.name, searchWord)
      );
    } else {
      // 検索ワードが設定されていない場合、全支店情報を表示
      list = [...this.allCompanyBranches];
    }
    this.setState({ list });
  }

  /**
   * @description コンポーネント内アイテムセット
   */
  setItems() {
    const existFlg = !_.isEmpty(this.state.list);
    if (existFlg === true) {
      return _.map(this.state.list, item => {
        if (
          this.props.companyFlg === false ||
          this.props.companyBranchId !== item.id
        ) {
          return (
            <FormDropdownRadio
              key={`${this.props.index}-${item.id}`}
              option={item}
              checked={this.state.selected.id === item.id}
              handleSelectedRow={() => {
                this.setState({ selected: item }, () => {
                  this.selectItem();
                });
              }}
              forId={`dropdown-${this.props.index}-${item.id}`}
            />
          );
        }
      });
    } else {
      return (
        <div className='table-has-no-data'>
          <div className='table-has-no-data__message'>
            {messageUtility.getMessage('I-000-046')}
          </div>
        </div>
      );
    }
  }

  /**
   * @description コンポーネント内アイテム選択
   */
  selectItem() {
    if (!_.isUndefined(this.state.selected.id)) {
      // JV支店を選択している場合
      this.props.onUpdate(this.state.selected);
    }
    this.setState({ show: false, searchWord: '' });
  }

  render() {
    const getDropdownLabel = () => {
      let label = !_.isUndefined(this.props.value)
        ? this.props.value
        : '支店を指定';
      return label;
    };

    return (
      <div className='dropdown-single-select dropdown-single-select__jv-company-branch' ref={this.parent}>
        <div
          className={`dropdown-single-select__header ${this.state.show &&
            'show'}`}
        >
          <div
            className={`dropdown-select${
              this.props.enable ? '' : '--disabled'
            }`}
            onClick={() => this.handleShowForm()}
          >
            <span className='dropdown-select__txt'>{getDropdownLabel()}</span>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </div>
        </div>
        {this.state.show && (
          <div
            id='form-dropdown-list'
            className={`dropdown dropdown--dropdown-list ${
              this.props.enable ? 'show' : ''
            }`}
          >
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  value={this.state.searchWord}
                  className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  onChange={e => this.inputSearchWord(e.target.value)}
                />
              </div>
              <div className='dropdown-single-select__scroll'>
                <ul className='single-select'>{this.setItems()}</ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/JvCompanyBranch.jsx